<template>
  <div class="download-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-background">
        <img :src="Images.download.background_1" alt="Background" class="hero-bg-image">
      </div>
      <div class="hero-content">
        <h1 class="hero-title">Joy Audio App</h1>
        <p class="hero-description"><span class="orange-text">Joy Audio App</span>是基于豆包大模型 + 火山引擎端侧 AI打造的一站式智能语音处理平台，核心为用户提供高效、精准的语音转写、翻译与智能交互服务，覆盖商务、学习、生活等全场景。</p>
        <div class="download-buttons">
          <div class="download-btn-container" @mousemove="showQrCode" @mouseleave="hideQrCode">
            <a href="https://apps.apple.com/us/app/joy-audio/id6480443439" target="_blank" rel="noopener noreferrer" class="download-btn ios-btn">
              <img :src="Images.download.ios" alt="Apple Store" class="platform-icon">
              <span class="btn-text">Apple Store下载</span>
            </a>
            <div class="qr-code-popup" :class="{ 'show': showIosQr }">
              <img :src="Images.download.ios_qr" alt="iOS QR Code" class="qr-code">
              <p class="qr-text">扫码下载</p>
            </div>
          </div>
          <div class="download-btn-container" @mousemove="showQrCode" @mouseleave="hideQrCode">
            <a href="https://oss.joygem.net/Joyaudio-release.apk" target="_blank" rel="noopener noreferrer" class="download-btn android-btn">
              <img :src="Images.download.android" alt="Android" class="platform-icon">
              <span class="btn-text">Android下载</span>
            </a>
            <div class="qr-code-popup" :class="{ 'show': showAndroidQr }">
              <img :src="Images.download.android_qr" alt="Android QR Code" class="qr-code">
              <p class="qr-text">扫码下载</p>
            </div>
          </div>
        </div>
        
        <!-- Features Section -->
        <div class="features-grid">
          <div class="feature-item" :style="{ backgroundImage: `url(${Images.download.icon_background})` }">
            <div class="feature-icon">
              <img :src="Images.download.icon_1" alt="录音转写" class="feature-img">
            </div>
            <h3 class="feature-title">录音转写</h3>
          </div>
          <div class="feature-item" :style="{ backgroundImage: `url(${Images.download.icon_background})` }">
            <div class="feature-icon">
              <img :src="Images.download.icon_2" alt="实时翻译" class="feature-img"> 
            </div>
            <h3 class="feature-title">实时翻译</h3>
          </div>
          <div class="feature-item" :style="{ backgroundImage: `url(${Images.download.icon_background})` }">
            <div class="feature-icon">
              <img :src="Images.download.icon_3" alt="智能对话" class="feature-img">
            </div>
            <h3 class="feature-title">智能对话</h3>
          </div>
          <div class="feature-item" :style="{ backgroundImage: `url(${Images.download.icon_background})` }">
            <div class="feature-icon">
              <img :src="Images.download.icon_4" alt="专属权益" class="feature-img">
            </div>
            <h3 class="feature-title">专属权益</h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Product Introduction Section -->
    <section class="product-intro-section">
      <div class="container">
        <div class="section-title">
          <h2 class="main-title">产品介绍</h2>
        </div>
        <div class="product-intro-content">
          <div class="feature-left">
            <div class="intro-feature">
              <p class="feature-desc">录音转写：支持现场、会议、通话录音，实时转文字+智能摘要，还能多语言识别；</p>
            </div>
            <div class="intro-feature">
              <p class="feature-desc">实时翻译：6种模式（同声传译、通话翻译等），覆盖27种语言，响应快、准确率高；</p>
            </div>
          </div>
          <div class="product-image">
            <img :src="Images.download.app" alt="App Screenshot" class="screenshot-image">
          </div>
          <div class="feature-right">
            <div class="intro-feature">
              <p class="feature-desc">智能对话：多角色陪伴+口语陪练，能答疑、纠错，适合学习和日常互动。</p>
            </div>
            <div class="intro-feature">
              <p class="feature-desc">全场景适配：覆盖国际会议、跨境沟通、课堂学习、内容创作等场景，支持多设备同步。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Scenes Section -->
    <section class="scenes-section">
      <div class="container">
        <div class="section-title">
          <h2 class="main-title">使用场景</h2>
        </div>
        <div class="scenes-grid">
          <div class="scene-item">
            <img :src="Images.download.scene_1" alt="商务会议" class="scene-image">
            <div class="scene-text">商务会议</div>
          </div>
          <div class="scene-item">
            <img :src="Images.download.scene_2" alt="外语学习" class="scene-image">
            <div class="scene-text">外语学习</div>
          </div>
          <div class="scene-item">
            <img :src="Images.download.scene_3" alt="跨境旅行" class="scene-image">
            <div class="scene-text">跨境旅行</div>
          </div>
          <div class="scene-item">
            <img :src="Images.download.scene_4" alt="内容创作" class="scene-image">
            <div class="scene-text">内容创作</div>
          </div>
        </div>
      </div>
    </section>


    <!-- Intelligent Dialogue Section -->
    <section class="intelligent-dialogue-section">
      <div class="container">
        <div class="dialogue-content">
          <div class="dialogue-image">
            <img :src="Images.download.Intelligent_dialogue" alt="智能对话" class="dialogue-screenshot">
          </div>
          <div class="dialogue-info">
            <h2 class="dialogue-title">智能对话</h2>
            <div class="dialogue-features">
              <div class="dialogue-feature">
                <p class="feature-text">场景降噪：通过AI算法实时识别环境，自动调节降噪/通透模式，不用手动切换；</p>
              </div>
              <div class="dialogue-feature">
                <p class="feature-text">音质优化：根据你的听歌偏好（摇滚/古典/人声），智能调整音效，定制专属听歌体验；</p>
              </div>
              <div class="dialogue-feature">
                <p class="feature-text">通话增强：AI识别通话背景噪音，精准放大你的人声，嘈杂环境也能"清"松通话。</p>
              </div>
            </div>
            <div class="dialogue-applicable">
              <p class="applicable-text">适用场景：通勤、办公、运动</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Real-time Translation Section -->
    <section class="translation-section">
      <div class="container">
        <div class="translation-content">
          <div class="translation-header">
            <h2 class="translation-title">实时翻译</h2>
            <p class="translation-description">如果您对我们的产品和服务有任何疑问，或者想了解更多信息，请随时与我们联系</p>
          </div>
          <div class="translation-buttons">
            <button class="translation-btn">同声传译</button>
            <button class="translation-btn">面对面翻译</button>
            <button class="translation-btn">双耳互译</button>
          </div>
          <div class="translation-screenshot-container">
            <img :src="Images.download.translation" alt="实时翻译" class="translation-main-screenshot">
          </div>
        </div>
      </div>
    </section>
          <!-- Recording Transcription Section -->
    <section class="recording-transcription-section">
      <div class="container">
        <div class="transcription-content">
          <div class="transcription-image">
            <img :src="Images.download.audio_transcription" alt="录音转写" class="transcription-screenshot">
          </div>
          <div class="transcription-info">
            <h2 class="transcription-title">录音转写</h2>
            <div class="transcription-features">
              <div class="transcription-feature">
                <p class="feature-text">场景降噪：通过AI算法实时识别环境，自动调节降噪/通透模式，不用手动切换；</p>
              </div>
              <div class="transcription-feature">
                <p class="feature-text">音质优化：根据你的听歌偏好（摇滚/古典/人声），智能调整音效，定制专属听歌体验；</p>
              </div>
              <div class="transcription-feature">
                <p class="feature-text">通话增强：AI识别通话背景噪音，精准放大你的人声，嘈杂环境也能"清"松通话。</p>
              </div>
            </div>
            <div class="transcription-applicable">
              <p class="applicable-text">适用场景：通勤、办公、运动</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Customer Reviews Section -->
    <section class="customer-reviews-section">
      <div class="container">
        <div class="reviews-content">
          <div class="reviews-header">
            <h2 class="reviews-title">客户评价</h2>
            <p class="reviews-description">如果您对我们的产品和服务有任何疑问，或者想了解更多信息，请随时与我们联系</p>
          </div>
          <div class="reviews-slider">
            <div class="slider-nav slider-nav-left">
              <span class="nav-arrow">‹</span>
            </div>
            <div class="reviews-container">
              <div class="reviews-grid" ref="reviewsGrid">
                <div class="review-card">
                  <div class="review-content">
                    <div class="reviewer-name">173***</div>
                    <div class="review-rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star star-empty">★</span>
                      <span class="star star-empty">★</span>
                    </div>
                    <p class="review-text">出境旅行离不开Joy Audio! 95%+准确率面对面翻译，字幕翻译+双耳互译，多端同步，跨境沟通、Vlog创作都省心！</p>
                  </div>
                </div>
                <div class="review-card">
                  <div class="review-content">
                    <div class="reviewer-name">173***1290</div>
                    <div class="review-rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <p class="review-text">出境旅行离不开Joy Audio! 95%+准确率面对面翻译，字幕翻译+双耳互译，多端同步，跨境沟通、Vlog创作都省心！</p>
                  </div>
                </div>
                <div class="review-card">
                  <div class="review-content">
                    <div class="reviewer-name">290</div>
                    <div class="review-rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <p class="review-text">95%+准确率面对面翻译，多端同步，跨境沟通都省心！</p>
                  </div>
                </div>
                <div class="review-card">
                  <div class="review-content">
                    <div class="reviewer-name">365</div>
                    <div class="review-rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <p class="review-text">Joy Audio的录音转写功能非常强大，会议记录变得轻松多了！</p>
                  </div>
                </div>
                <div class="review-card">
                  <div class="review-content">
                    <div class="reviewer-name">458</div>
                    <div class="review-rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <p class="review-text">智能对话功能让学习变得更有趣，推荐给所有语言学习者！</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="slider-nav slider-nav-right">
              <span class="nav-arrow">›</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Images } from '@/utils/imageLoader';

export default {
  name: 'DownloadView',
  data() {
    return {
      currentIndex: 0,
      showIosQr: false,
      showAndroidQr: false,
      Images
    }
  },
  mounted() {
    // 初始化轮播功能
    this.initSlider()
    this.updateCardPositions()
  },
  methods: {
    showQrCode(event) {
      const target = event.currentTarget;
      if (target.querySelector('.ios-btn')) {
        this.showIosQr = true;
      } else if (target.querySelector('.android-btn')) {
        this.showAndroidQr = true;
      }
    },
    hideQrCode(event) {
      const target = event.currentTarget;
      if (target.querySelector('.ios-btn')) {
        this.showIosQr = false;
      } else if (target.querySelector('.android-btn')) {
        this.showAndroidQr = false;
      }
    },
    initSlider() {
      const leftBtn = document.querySelector('.slider-nav-left')
      const rightBtn = document.querySelector('.slider-nav-right')
      
      if (!leftBtn || !rightBtn) return
      
      leftBtn.addEventListener('click', () => {
        this.moveLeft()
      })
      
      rightBtn.addEventListener('click', () => {
        this.moveRight()
      })
    },
    moveLeft() {
      const cards = document.querySelectorAll('.review-card')
      if (cards.length === 0) return
      
      this.currentIndex = (this.currentIndex - 1 + cards.length) % cards.length
      this.updateCardPositions()
    },
    moveRight() {
      const cards = document.querySelectorAll('.review-card')
      if (cards.length === 0) return
      
      this.currentIndex = (this.currentIndex + 1) % cards.length
      this.updateCardPositions()
    },
    updateCardPositions() {
      const cards = document.querySelectorAll('.review-card')
      if (cards.length === 0) return
      
      cards.forEach((card, index) => {
        // 计算卡片相对于当前活动卡片的位置
        const position = (index - this.currentIndex + cards.length) % cards.length
        
        // 重置所有样式
        card.style.opacity = '0.8'
        card.style.transform = 'translate(-50%, -50%) scale(0.9)'
        card.style.zIndex = '1'
        card.style.backgroundColor = 'white'
        card.style.border = 'none'
        card.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)'
        card.style.width = '300px'
        card.classList.remove('active')
        
        // 根据位置设置不同的样式
        if (position === 0) {
          // 中间活动卡片
          card.style.opacity = '1'
          card.style.transform = 'translate(-50%, -50%) scale(1)'
          card.style.zIndex = '5'
          card.style.backgroundColor = '#fff8f0'
          card.style.border = '2px solid #ff6b00'
          card.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.15)'
          card.classList.add('active')
        } else if (position === 1) {
          // 右侧第一张卡片
          card.style.opacity = '0.9'
          card.style.transform = 'translate(calc(-50% + 200px), -50%) scale(0.95)'
          card.style.zIndex = '4'
        } else if (position === 2) {
          // 右侧第二张卡片
          card.style.opacity = '0.8'
          card.style.transform = 'translate(calc(-50% + 400px), -50%) scale(0.9)'
          card.style.zIndex = '3'
        } else if (position === 3) {
          // 左侧第二张卡片
          card.style.opacity = '0.8'
          card.style.transform = 'translate(calc(-50% - 400px), -50%) scale(0.9)'
          card.style.zIndex = '3'
        } else if (position === 4) {
          // 左侧第一张卡片
          card.style.opacity = '0.9'
          card.style.transform = 'translate(calc(-50% - 200px), -50%) scale(0.95)'
          card.style.zIndex = '4'
        }
      })
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero {
  position: relative;
  height: auto;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 25vh;
  padding-bottom: 60px;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
}

.hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-content {
  text-align: center;
  color: #333;
  max-width: 800px;
  
}

.hero-title {
  font-size: 70px;
  font-weight: bold;
  margin: 0 0 20px;
  background: linear-gradient(90deg, #4BCACD -1%, #2468F2 47%, #CF5E58 104%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-description {
  font-size: 18px;
  line-height: 1.6;
  margin: 0 0 40px;
  color: #666;
}

.orange-text {
  color: #ff6b00;
  font-weight: 500;
}

.download-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 60px;
}

.download-btn-container {
  position: relative;
  display: inline-block;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  border: none;
  border-radius: 26px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  z-index: 1;
}

.ios-btn {
  background-color: #FFFFFF;
}

.android-btn {
  background-color: #FFFFFF;
}

.platform-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.btn-text {
  white-space: nowrap;
  color: #333;
}

/* QR Code Popup */
.qr-code-popup {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 10;
}

.qr-code-popup::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}

.qr-code-popup.show {
  opacity: 1;
  visibility: visible;
  margin-top: 10px;
}

.qr-code {
  width: 150px;
  height: 150px;
  margin-bottom: 10px;
  object-fit: contain;
}

.qr-text {
  font-size: 14px;
  color: #333;
  margin: 0;
  text-align: center;
  font-weight: 500;
}



.features-grid {
  display: flex;
  justify-content: center;
  gap: 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 160px;
  height: 180px;
  background-image: url('@/assets/download/icon_background.png');
  background-size: cover;
  background-position: center;
  padding: 20px;
  box-sizing: border-box;
}

.feature-icon {
  width: 120px;
  height: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-img {
  width: 80%;
  height: 80%;
  object-fit: contain;
}

.feature-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0;
}

/* App Showcase */
.app-showcase {
  padding: 60px 0;
  background-color: #f8f8f8;
}

.app-screenshot {
  max-width: 300px;
  height: auto;
  margin: 0 auto;
  display: block;
}

/* Scenes Section */
.scenes-section {
  padding: 80px 0;
  background-color: transparent;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.main-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.scenes-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.scene-item {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
}

.scene-image {
  width: 100%;
  height: auto;
  display: block;
}

.scene-text {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  background-color: transparent;
  color: white;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  border: none;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Recording Transcription Section */
.recording-transcription-section {
  padding: 60px 0;
  background-color: #fff;
}

.transcription-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.transcription-image {
  flex: 0 0 auto;
}

.transcription-screenshot {
  width: 500px;
  height: auto;
  object-fit: contain;
}

.transcription-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.transcription-title {
  font-size: 32px;
  font-weight: bold;
  color: #ff6b00;
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 3px solid #ff6b00;
  width: fit-content;
}

.transcription-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.transcription-feature {
  display: flex;
  align-items: flex-start;
}

.transcription-applicable {
  margin-top: 10px;
}

/* Intelligent Dialogue Section */
.intelligent-dialogue-section {
  padding: 60px 0;
  background-color: #fff;
}

.dialogue-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.dialogue-image {
  flex: 0 0 auto;
}

.dialogue-screenshot {
  width: 500px;
  height: auto;
  object-fit: contain;
}

.dialogue-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.dialogue-title {
  font-size: 32px;
  font-weight: bold;
  color: #ff6b00;
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 3px solid #ff6b00;
  width: fit-content;
}

.dialogue-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dialogue-feature {
  display: flex;
  align-items: flex-start;
}

.feature-text {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin: 0;
}

.dialogue-applicable {
  margin-top: 10px;
}

.applicable-text {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin: 0;
  font-weight: 500;
}

/* Customer Reviews Section */
.customer-reviews-section {
  padding: 80px 0;
  background-color: #fff;
}

.reviews-content {
  display: flex;
  flex-direction: column;
  gap: 50px;
  max-width: 1200px;
  margin: 0 auto;
}

.reviews-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.reviews-title {
  font-size: 32px;
  font-weight: bold;
  color: #ff6b00;
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 3px solid #ff6b00;
  width: fit-content;
}

.reviews-description {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin: 0;
  text-align: center;
  max-width: 800px;
}

.reviews-slider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  position: relative;
  padding: 40px 0;
}

.slider-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #f5f5f5;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 100;
  flex-shrink: 0;
}

.slider-nav:hover {
  background-color: #e0e0e0;
}

.nav-arrow {
  font-size: 24px;
  color: #666;
}

.reviews-container {
  overflow: hidden;
  width: 100%;
  max-width: 900px;
  position: relative;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reviews-grid {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
}

.review-card {
  background-color: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 280px;
  transition: all 0.3s ease;
  opacity: 0.8;
  z-index: 1;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0.9);
}

.review-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  text-align: center;
}

.reviewer-name {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0;
}

.review-rating {
  display: flex;
  gap: 4px;
  margin: 10px 0;
}

.star {
  font-size: 18px;
  color: #ffd700;
}

.star-empty {
  color: #e0e0e0;
}

.review-title {
  font-size: 24px;
  font-weight: bold;
  color: #ff6b00;
  margin: 10px 0;
}

.review-text {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin: 0;
  text-align: center;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.reviewer-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.review-rating {
  display: flex;
  gap: 4px;
}

.star {
  font-size: 18px;
  color: #ffd700;
}

.star-empty {
  color: #e0e0e0;
}

.review-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.review-title {
  font-size: 20px;
  font-weight: bold;
  color: #ff6b00;
  margin: 0;
}

.review-content p {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin: 0;
}

/* Real-time Translation Section */
.translation-section {
  padding: 60px 0;
  background-color: #fff;
}

.translation-content {
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.translation-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.translation-title {
  font-size: 32px;
  font-weight: bold;
  color: #ff6b00;
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 3px solid #ff6b00;
  width: fit-content;
}

.translation-description {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin: 0;
  text-align: center; 
  max-width: 800px;
}

.translation-buttons {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.translation-btn {
  padding: 12px 30px;
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.translation-btn:hover {
  background-color: #e55e00;
  transform: translateY(-2px);
}

.translation-screenshot-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.translation-main-screenshot {
  width: 900px;
  height: auto;
  object-fit: contain;
}

/* Product Introduction Section */
.product-intro-section {
  padding: 5px 0 60px;
  background-color: white;
  position: relative;
  margin-top: -300px;
}

.product-intro-section .feature-desc {
  color: #333;
}

.product-intro-section .main-title {
  color: #ff6b00;
  padding-bottom: 10px;
  border-bottom: 3px solid #ff6b00;
  width: fit-content;
  margin: 0 auto 10px;
}

.product-intro-content {
  max-width: 1000px;
  margin: 0 auto;
}

.product-intro-section .feature-heading {
  color: #ff6b00;
  border-bottom: 2px solid #ff6b00;
  padding-bottom: 5px;
}

.product-intro-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-left, .feature-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.intro-feature {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.feature-heading {
  font-size: 20px;
  font-weight: bold;
  color: #ff6b00;
  margin: 0;
}

.feature-desc {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin: 0;
}

.product-image {
  flex: 0 0 auto;
}

.screenshot-image {
  width: 250px;
  height: auto;
  object-fit: contain;
}

/* Secondary CTA */
.secondary-cta {
  padding: 80px 0;
  background-color: transparent;
}

.cta-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.cta-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin: 0 0 20px;
}

.cta-description {
  font-size: 18px;
  line-height: 1.6;
  margin: 0 0 40px;
  color: #666;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .product-intro-content {
    flex-direction: column;
    gap: 40px;
  }
  
  .dialogue-content {
    flex-direction: column;
    gap: 40px;
  }
  
  .feature-left, .feature-right {
    width: 100%;
    max-width: 400px;
  }
  
  .dialogue-screenshot {
    width: 400px;
  }
  
  .translation-main-screenshot {
    width: 700px;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 36px;
  }
  
  .hero-description {
    font-size: 16px;
  }
  
  .download-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .features-grid {
    flex-direction: column;
    gap: 40px;
  }
  
  .scenes-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .cta-title {
    font-size: 28px;
  }
  
  .reviews-grid {
    flex-direction: column;
    gap: 30px;
  }
  
  .review-card {
    opacity: 1;
    transform: scale(1) rotateY(0deg) !important;
    width: 90% !important;
    margin: 0 auto;
  }
  
  .reviews-grid {
    gap: 20px;
    padding: 20px 0;
  }
}
</style>